import styled from "styled-components";

// Container interno do modal (dentro de ModalBody)
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

// Header agora é apenas a progress bar inline (modal header cuida do título)
export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 12px 16px;
  background: ${({ theme }) => theme.body === '#fafbfc' ? 'rgba(0,0,0,0.02)' : 'rgba(255,255,255,0.02)'};
  border: 1px solid ${({ theme }) => theme.border};
  border-radius: 12px;

  .title-group {
    flex: 1;
    min-width: 0;

    h2 {
      margin: 0 0 4px 0;
      font-size: 0.85em;
      font-weight: 600;
      color: ${({ theme }) => theme.text};
      display: flex;
      align-items: center;
      gap: 8px;

      svg { color: #10b981; font-size: 1.1em; }
    }

    p {
      color: ${({ theme }) => theme.text};
      opacity: 0.5;
      margin: 0;
      font-size: 0.75em;
      display: flex;
      align-items: center;
      gap: 6px;

      .ws-status {
        display: inline-flex;
        &.connected { color: #10b981; }
        &.disconnected { color: #ef4444; }
      }
    }
  }

  .global-progress {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 5px;

    .progress-text {
      font-size: 0.8em;
      color: ${({ theme }) => theme.text};
      font-weight: 500;
      opacity: 0.7;

      span { color: #10b981; font-weight: 700; }
      small { opacity: 0.5; }
    }

    .progress-bar-container {
      width: 160px;
      height: 5px;
      background: ${({ theme }) => theme.border};
      border-radius: 3px;
      overflow: hidden;

      .progress-fill {
        height: 100%;
        background: linear-gradient(90deg, #10b981, #34d399);
        border-radius: 3px;
        transition: width 0.3s ease;
      }
    }
  }
`;

export const TaskList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  max-height: 400px;
  overflow-y: auto;
  padding-right: 4px;

  &::-webkit-scrollbar { width: 4px; }
  &::-webkit-scrollbar-track { background: transparent; }
  &::-webkit-scrollbar-thumb { background: ${({ theme }) => theme.border}; border-radius: 2px; }
`;

export const TaskItem = styled.div`
  background: ${({ theme }) => theme.body === '#fafbfc' ? 'rgba(0,0,0,0.01)' : 'rgba(255,255,255,0.02)'};
  border: 1px solid ${({ theme }) => theme.border};
  border-radius: 10px;
  padding: 10px 14px;
  display: flex;
  align-items: center;
  gap: 12px;
  transition: all 0.2s ease;

  &.active {
    border-color: rgba(16, 185, 129, 0.4);
    background: rgba(16, 185, 129, 0.03);
  }

  &.completed {
    opacity: 0.55;
  }

  &.pending {
    opacity: 0.35;
  }

  .task-icon {
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    font-size: 0.9em;
    flex-shrink: 0;

    &.pending {
      background: ${({ theme }) => theme.border};
      color: ${({ theme }) => theme.text};
      opacity: 0.4;
    }

    &.active {
      background: rgba(16, 185, 129, 0.12);
      color: #10b981;
      animation: pulse 1.5s infinite;
    }

    &.completed {
      background: rgba(16, 185, 129, 0.1);
      color: #10b981;
    }

    &.error {
      background: rgba(239, 68, 68, 0.1);
      color: #ef4444;
    }
  }

  @keyframes pulse {
    0%, 100% { opacity: 1; }
    50% { opacity: 0.5; }
  }

  .task-info {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 5px;
    min-width: 0;

    .task-header {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .task-name {
        font-size: 0.82em;
        font-weight: 500;
        color: ${({ theme }) => theme.text};
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .task-status {
        font-size: 0.7em;
        padding: 3px 8px;
        border-radius: 6px;
        font-weight: 500;
        flex-shrink: 0;

        &.pending {
          background: rgba(107, 114, 128, 0.08);
          color: #6b7280;
        }

        &.active {
          background: rgba(59, 130, 246, 0.1);
          color: #3b82f6;
        }

        &.completed {
          background: rgba(16, 185, 129, 0.1);
          color: #10b981;
        }

        &.error {
          background: rgba(239, 68, 68, 0.1);
          color: #ef4444;
        }
      }
    }

    .task-progress {
      height: 4px;
      background: ${({ theme }) => theme.border};
      border-radius: 2px;
      overflow: hidden;

      .progress-fill {
        height: 100%;
        border-radius: 2px;
        transition: width 0.3s ease;

        &.active {
          background: linear-gradient(90deg, #3b82f6, #60a5fa);
          animation: progressPulse 1.5s infinite;
        }

        &.completed {
          background: #10b981;
        }

        &.error {
          background: #ef4444;
        }
      }
    }

    @keyframes progressPulse {
      0%, 100% { opacity: 1; }
      50% { opacity: 0.7; }
    }

    .task-details {
      display: flex;
      gap: 12px;
      font-size: 0.72em;
      color: ${({ theme }) => theme.text};
      opacity: 0.5;

      span {
        display: flex;
        align-items: center;
        gap: 3px;
      }
    }
  }
`;

export const StatusMessage = styled.div`
  margin-top: 12px;
  padding: 14px 16px;
  background: ${({ theme }) => theme.body === '#fafbfc' ? 'rgba(0,0,0,0.01)' : 'rgba(255,255,255,0.02)'};
  border: 1px solid ${({ theme }) => theme.border};
  border-radius: 12px;
  display: flex;
  align-items: center;
  gap: 14px;

  &.success {
    border-color: rgba(16, 185, 129, 0.3);
    background: rgba(16, 185, 129, 0.04);
  }

  &.error {
    border-color: rgba(239, 68, 68, 0.3);
    background: rgba(239, 68, 68, 0.04);
  }

  .status-icon {
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
    font-size: 1.2em;
    flex-shrink: 0;

    &.success {
      background: rgba(16, 185, 129, 0.12);
      color: #10b981;
    }

    &.error {
      background: rgba(239, 68, 68, 0.12);
      color: #ef4444;
    }

    &.processing {
      background: rgba(59, 130, 246, 0.12);
      color: #3b82f6;
      animation: spin 1s linear infinite;
    }
  }

  @keyframes spin {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  }

  .status-text {
    flex: 1;
    min-width: 0;

    h4 {
      margin: 0 0 2px 0;
      font-size: 0.9em;
      font-weight: 600;
      color: ${({ theme }) => theme.text};
    }

    p {
      margin: 0;
      font-size: 0.78em;
      color: ${({ theme }) => theme.text};
      opacity: 0.5;
    }
  }

  .status-action {
    button {
      padding: 9px 18px;
      border-radius: 10px;
      font-weight: 600;
      font-size: 0.82em;
      cursor: pointer;
      border: none;
      background: #10b981;
      color: white;
      transition: all 0.2s;

      &:hover {
        background: #059669;
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);
      }
    }
  }
`;
